export default __webpack_public_path__ + "static/media/gallery-7-2.d9fbe29e.jpg";